import React from 'react';
import { IconButton, Typography } from '../../UIKit';
import { IErrorResponse } from '../../Models/DTO/Error.models';
import { WHITE, ICON_ERROR } from '../../Constants/Colors.constants';
import { Refresh, SvgIconComponent } from '@mui/icons-material';
import { makeStyles } from '~/UIKit/Style';
import { useTranslation } from 'react-i18next';
import { FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { extractErrorMessage, messageFromTranslatableMessages } from '~/Helpers/Error.helper';

interface IErrorProps {
  error: IErrorResponse | undefined | null;
  errorAction?: () => void;
  ErrorIcon?: SvgIconComponent;
}

const useStyles = makeStyles({
  errorContainer: {
    fontSize: FONT_SIZE_SMALLISH,
    color: WHITE,
    background: ICON_ERROR,
    padding: '4px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'hidden',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  errorButton: {
    color: 'inherit',
    padding: 12,
    margin: -12,
  },
});

export const Error = ({ error, errorAction, ErrorIcon = Refresh }: IErrorProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const extractedErrors = extractErrorMessage(error, t);
  // had to write it like this because TS was complaining.
  if (error === null || error === undefined || !extractedErrors) {
    return null;
  }
  if (error.messages) {
    return (
      <div className={classes.errorContainer}>
        {error.messages.map((singleError, index) => (
          <div key={`${singleError.key}_${index}`}>
            <Typography style={{ color: WHITE }}>
              {messageFromTranslatableMessages([singleError], t)}
            </Typography>
          </div>
        ))}
        {errorAction && (
          <IconButton className={classes.errorButton} onClick={errorAction} size="large">
            <ErrorIcon />
          </IconButton>
        )}
      </div>
    );
  }

  return (
    <div className={classes.errorContainer}>
      {extractedErrors}
      {errorAction && (
        <IconButton className={classes.errorButton} onClick={errorAction} size="large">
          <ErrorIcon />
        </IconButton>
      )}
    </div>
  );
};
